import { useEffect } from "react";

function ChatCompleteNotification({
  systemStatus,
  message,
  displaySummaryWindow,
  setDisplaySummaryWindow,
}) {
  let placeholderMessage =
    "Thank you, User. Your reservation at Restaurant for 5 people on Wednesday, September 11, 2024, at 1:00 PM is on hold. You have not mentioned any dietary restrictions or special requests. A reminder SMS will be sent to you before the day of your reservation. Your booking id is ABC123456. Thank you for your call!";

  useEffect(() => {
    if (systemStatus === "complete") {
      setDisplaySummaryWindow(true);
    }
  }, [systemStatus, setDisplaySummaryWindow]);

  return (
    <div
      className="axify__widget-notification"
      data-state={displaySummaryWindow === true ? "open" : "closed"}
      aria-hidden={displaySummaryWindow !== true ? "true" : "false"}
    >
      <div className="axify__widget-notification-inner">
        <div className="axify__widget-notification-header" role="heading" aria-level="2">
          Summary
        </div>
        <div className="axify__widget-notification-content" role="note">
          <p>{message.content ? message.content : placeholderMessage}</p>
        </div>
      </div>
    </div>
  );
}

export default ChatCompleteNotification;
